<template>
	<BasicBanner :dismissal-key="dismissalKey" data-context="vcx investment window banner">
		<!-- eslint-disable-next-line vue/no-v-html -->
		<p class="mr-200 balance-text" v-html="text" />
	</BasicBanner>
</template>

<script setup lang="ts">
import BasicBanner from '@components/layout/basic-banner.vue';

interface Props {
	text: string;
}

defineProps<Props>();

const dismissalKey = 'dismiss-vcx-investment-window-banner';
</script>

<style scoped>
.balance-text {
	text-wrap: balance;
	-webkit-text-wrap: balance;
}
</style>
